import React from 'react';
import { useRecoilValue } from 'recoil';
import { entityKeySelector } from '../../syncEngine/selectors/entities';

export function EntityKey({ id }: { id: string }) {
  const key = useRecoilValue(entityKeySelector(id));
  return <>{key}</>;
}
